import { sendTrackEvent } from './Events'
import { GloboId } from './GloboId'
import {
  executeQueue,
  GLOBOID_AVAILABLE_CALLBACK_QUEUE_NAME,
  GLOBOID_READY_CALLBACK_QUEUE_NAME
} from './StageQueueManager'
import { decodeJWT, extractGloboIdToken, generateUUID } from './Utils'

class GloboIdClient {
  constructor() {
    this.initGloboId()
  }
  async initGloboId() {
    this.globoId = new GloboId()
    this.stageQueueMap = {}
    await executeQueue(this.stageQueueMap, GLOBOID_AVAILABLE_CALLBACK_QUEUE_NAME, this.globoId)
  }
  async setup(settings) {
    this.settings = settings
    const setupResult = await this.globoId.setup(this.settings)
    await executeQueue(this.stageQueueMap, GLOBOID_READY_CALLBACK_QUEUE_NAME, this.globoId)
    return setupResult
  }
}

class GloboIdClientMap {
  constructor() {
    this.globoIdMap = {}
    this.setupQueue = Promise.resolve(true)
  }

  addSetupEnqueue(setup, settings) {
    return new Promise((resolve, reject) => {
      const eventType = 'SDK.WEB.LIB_INIT'

      const initEvent = {
        clientId: settings.clientId,
        // eslint-disable-next-line no-undef
        sdkVersion: SDK_VERSION,
        sessionManagement: settings.sessionManagement,
        legacyCompatible: settings.legacyCompatible,
        trackId: generateUUID(),
      }

      this.setupQueue = this.setupQueue
        .then(() => {
          const startedEventType = `${eventType}.STARTED`
          initEvent.eventType = startedEventType
          sendTrackEvent(initEvent)
          return setup()
        } )
        .then(() => { 
          const succeededEventType = `${eventType}.SUCCEEDED`
          initEvent.eventType = succeededEventType
          sendTrackEvent(initEvent)
          return resolve()
        })
        .catch((e) => {
          const failedEventType = `${eventType}.FAILED`
          initEvent.eventType = failedEventType
          initEvent.errorReason = e.error

          sendTrackEvent(initEvent)
          return reject(e)
        })
    })
  }
  async initNewGloboIdClient(settings) {
    const setup = async () => {

      const clientId = settings.clientId
      this.globoIdMap[clientId] = new GloboIdClient()
      console.debug('Running setup from clientId:', settings.clientId)
      return await this.globoIdMap[clientId].setup(settings)
    }
    console.debug(`Adding the clientID:${settings.clientId} setup to the queue`)
    return await this.addSetupEnqueue(setup, settings)
  }

  getGloboIdClient(clientId) {
    return this.globoIdMap[clientId]
  }

  async getPreviewUser() {
    const cookies = document.cookie
    const globoIdJWT = extractGloboIdToken(cookies)

    return decodeJWT(globoIdJWT)
  }
}
export default GloboIdClientMap